import { IExportPreferenceService } from '@src/slide/application/service/export-preference-service/core/export-preference-service.interface';
import userLocalStorage, { LocalStorageKeys } from '@src/slide/infrastructure/module/independent/local-storage';

enum PreferKeys {
    attachment = 'attachmentPreferenceKey',
    embedFont = 'embedFontPreferenceKey'
}

const preferMap = {
    [PreferKeys.attachment]: LocalStorageKeys.ATTACHMENT as LocalStorageKeys.ATTACHMENT,
    [PreferKeys.embedFont]: LocalStorageKeys.EMBEDFONT as LocalStorageKeys.EMBEDFONT,
};

// TODO: 目前此service 只放了记住偏好设置的逻辑，但其实 menu-manager 中导出的逻辑都应该放在这里
/**
 * 导出偏好设置服务，可以修改并记录附件导出和字体导出的偏好设置
 */
export class ExportPreferenceService implements IExportPreferenceService {
    public get exportAttachmentPreference(): boolean {
        return this.getPreferenceByKey(PreferKeys.attachment);
    }

    public set exportAttachmentPreference(preference: boolean) {
        this.setPreferenceByKey(PreferKeys.attachment, preference);
    }

    public get exportFontPreference(): boolean {
        return this.getPreferenceByKey(PreferKeys.embedFont);
    }

    public set exportFontPreference(preference: boolean) {
        this.setPreferenceByKey(PreferKeys.embedFont, preference);
    }

    private getPreferenceByKey<T extends PreferKeys>(key: T) {
        const res = userLocalStorage.getItem(preferMap[key]);
        if (res !== null) return res;
        this.setPreferenceByKey(key, true);
        return true;
    }

    private setPreferenceByKey<T extends PreferKeys>(key: T, preference: boolean): void {
        userLocalStorage.setItem(preferMap[key], preference);
    }
}
